/**
 * BOTANIX ERP — Auth Context v3
 * Strict role-based access control
 */
import React, { createContext, useContext, useState, useEffect } from 'react';

const API = 'https://api.buddygolfers.com/api';

export const ROLES = {
 SUPER_ADMIN: 'Super Admin',
 ADMIN: 'Admin',
 HR_ADMIN: 'HR Admin',
 RESORT_GM: 'Resort GM',
 MARKETING: 'Marketing',
 SALES: 'Sales',
 SALES_DIRECTOR: 'Sales Director',
 FRONT_OFFICE: 'Front Office',
 KITCHEN_MANAGER: 'Kitchen Manager',
 FB_MANAGER: 'F&B Manager',
 HOUSEKEEPING: 'Housekeeping Manager',
 HORTICULTURE: 'Horticulture Manager',
 ACTIVITY: 'Activity Manager',
 CONSTRUCTION: 'Construction Manager',
 ACCOUNTS: 'Accounts',
 PURCHASE: 'Purchase Manager',
 STORE: 'Store Manager',
 STAFF: 'Staff',
};

export const PERMS = {
 NONE: 0, VIEW: 1, CREATE: 2, EDIT: 3,
 APPROVE: 4, DELETE: 5, EXPORT: 6, ADMIN: 7,
};

// ── ACCESS MATRIX — who can see what ─────────────────────────────────────────
// 0=No Access, 1=View, 2=Create, 3=Edit, 4=Approve, 5=Delete, 6=Export, 7=Admin
export const ACCESS_MATRIX = {
 // SA AD HR GM MKT SLS FO CHF FB HK HRT ACT CON ACC PUR STR
 dashboard: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:1,RESORT_GM:0,MARKETING:0,SALES:0,FRONT_OFFICE:0,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:1,PURCHASE:0,STORE:0 },
 bookings: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:7,MARKETING:0,SALES:7,FRONT_OFFICE:0,KITCHEN_MANAGER:1,FB_MANAGER:1,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:1,PURCHASE:0,STORE:0 },
 rooms: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:3,MARKETING:0,SALES:1,FRONT_OFFICE:7,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:3,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:0,STORE:0 },
 events: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:3,MARKETING:0,SALES:7,FRONT_OFFICE:1,KITCHEN_MANAGER:1,FB_MANAGER:3,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:3,CONSTRUCTION:0,ACCOUNTS:1,PURCHASE:0,STORE:0 },
 activities: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:3,MARKETING:0,SALES:1,FRONT_OFFICE:1,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:7,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:0,STORE:0 },
 housekeeping: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:7,MARKETING:0,SALES:0,FRONT_OFFICE:1,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:7,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:0,STORE:0 },
 inventory: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:3,MARKETING:0,SALES:0,FRONT_OFFICE:0,KITCHEN_MANAGER:3,FB_MANAGER:3,HOUSEKEEPING:0,HORTICULTURE:1,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:1,PURCHASE:7,STORE:7 },
 kitchen_mgmt: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:1,MARKETING:0,SALES:0,FRONT_OFFICE:0,KITCHEN_MANAGER:7,FB_MANAGER:7,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:1,STORE:1 },
 horticulture: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:1,MARKETING:0,SALES:0,FRONT_OFFICE:0,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:7,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:1,STORE:1 },
 construction: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:1,MARKETING:0,SALES:0,FRONT_OFFICE:0,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:7,ACCOUNTS:0,PURCHASE:3,STORE:0 },
 accounts: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:1,MARKETING:0,SALES:0,FRONT_OFFICE:0,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:1,ACCOUNTS:7,PURCHASE:1,STORE:0 },
 hr: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:7,RESORT_GM:3,MARKETING:0,SALES:0,SALES_DIRECTOR:7,FRONT_OFFICE:0,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:0,STORE:0 },
 marketing: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:1,MARKETING:0,SALES:0,FRONT_OFFICE:0,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:0,STORE:0 },
 social_media: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:1,MARKETING:7,SALES:3,FRONT_OFFICE:0,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:0,STORE:0 },
 dynamic_pricing:{ SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:1,MARKETING:0,SALES:0,FRONT_OFFICE:0,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:1,PURCHASE:0,STORE:0 },
 gst_config: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:0,MARKETING:0,SALES:0,FRONT_OFFICE:0,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:7,PURCHASE:0,STORE:0 },
 user_management:{ SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:0,MARKETING:0,SALES:0,SALES_DIRECTOR:7,FRONT_OFFICE:0,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:0,STORE:0 },
 session_logs: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:3,RESORT_GM:0,MARKETING:0,SALES:0,FRONT_OFFICE:0,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:0,STORE:0 },
 sales_dashboard: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:0,MARKETING:0,SALES:7,FRONT_OFFICE:0,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:0,STORE:0 },
 sales_performance: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:1,MARKETING:0,SALES:0,FRONT_OFFICE:0,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:0,STORE:0 },
 reports: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:1,RESORT_GM:1,MARKETING:0,SALES:1,FRONT_OFFICE:0,KITCHEN_MANAGER:1,FB_MANAGER:1,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:1,ACCOUNTS:7,PURCHASE:0,STORE:0 },
 crm: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:1,MARKETING:7,SALES:7,SALES_DIRECTOR:0,FRONT_OFFICE:0,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:0,STORE:0 },
 meal_forecast: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:7,MARKETING:0,SALES:0,FRONT_OFFICE:0,KITCHEN_MANAGER:7,FB_MANAGER:7,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:0,STORE:0 },
 botanix_ai: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:1,RESORT_GM:7,MARKETING:1,SALES:7,FRONT_OFFICE:7,KITCHEN_MANAGER:7,FB_MANAGER:7,HOUSEKEEPING:1,HORTICULTURE:1,ACTIVITY:1,CONSTRUCTION:1,ACCOUNTS:7,PURCHASE:1,STORE:1 },
 gm_dashboard: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:7,MARKETING:0,SALES:0,FRONT_OFFICE:0,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:0,STORE:0 },
 front_office: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:7,MARKETING:0,SALES:0,FRONT_OFFICE:7,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:0,STORE:0 },
 room_management: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:7,MARKETING:0,SALES:1,FRONT_OFFICE:7,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:3,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:0,STORE:0 },
 property_config: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:3,MARKETING:0,SALES:0,FRONT_OFFICE:0,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:0,PURCHASE:0,STORE:0 },
 settings: { SUPER_ADMIN:7,ADMIN:7,HR_ADMIN:0,RESORT_GM:3,MARKETING:0,SALES:0,FRONT_OFFICE:0,KITCHEN_MANAGER:0,FB_MANAGER:0,HOUSEKEEPING:0,HORTICULTURE:0,ACTIVITY:0,CONSTRUCTION:0,ACCOUNTS:1,PURCHASE:0,STORE:0 },
};

export const SAMPLE_USERS = [
 { id:1, name:'Atul Sharma', email:'atul@botanix.in', mobile:'9810000001', password:'Admin@123', role:'SUPER_ADMIN', dept:'Management', resort:'All', status:'Active', avatar:'AS' },
 { id:2, name:'Rajesh Sharma', email:'rajesh@botanix.in', mobile:'9810000002', password:'Admin@123', role:'ADMIN', dept:'Management', resort:'Botanix Damdama', status:'Active', avatar:'RS' },
 { id:3, name:'Pooja Rawat', email:'pooja@botanix.in', mobile:'9810000003', password:'Sales@123', role:'SALES', dept:'Sales & CRM', resort:'Botanix Damdama', status:'Active', avatar:'PR' },
 { id:4, name:'Sunita Verma', email:'sunita@botanix.in', mobile:'9810000004', password:'HR@12345', role:'HR_ADMIN', dept:'HR', resort:'All', status:'Active', avatar:'SV' },
 { id:5, name:'Mohit Gupta', email:'mohit@botanix.in', mobile:'9810000005', password:'GM@12345', role:'RESORT_GM', dept:'Management', resort:'Botanix Damdama', status:'Active', avatar:'MG' },
 { id:6, name:'Priya Singh', email:'priya@botanix.in', mobile:'9810000006', password:'Mkt@12345', role:'MARKETING', dept:'Marketing', resort:'All', status:'Active', avatar:'PS' },
 { id:7, name:'Suresh Kumar', email:'suresh@botanix.in', mobile:'9810000007', password:'Chef@123', role:'KITCHEN_MANAGER', dept:'Kitchen', resort:'Botanix Damdama', status:'Active', avatar:'SK' },
 { id:8, name:'Deepak Chauhan', email:'deepak@botanix.in', mobile:'9810000008', password:'HK@12345', role:'HOUSEKEEPING', dept:'Housekeeping', resort:'Botanix Damdama', status:'Active', avatar:'DC' },
 { id:9, name:'Ramesh Yadav', email:'ramesh@botanix.in', mobile:'9810000009', password:'Hort@123', role:'HORTICULTURE', dept:'Horticulture', resort:'Botanix Damdama', status:'Active', avatar:'RY' },
 { id:10, name:'Amit Nagar', email:'amit@botanix.in', mobile:'9810000010', password:'Const@123', role:'CONSTRUCTION', dept:'Projects', resort:'Botanix Damdama', status:'Active', avatar:'AN' },
 { id:11, name:'Kavita Joshi', email:'kavita@botanix.in', mobile:'9810000011', password:'Accts@123', role:'ACCOUNTS', dept:'Finance', resort:'All', status:'Active', avatar:'KJ' },
 { id:12, name:'Rohit Mehra', email:'rohit@botanix.in', mobile:'9810000012', password:'FO@12345', role:'FRONT_OFFICE', dept:'Front Office', resort:'Botanix Damdama', status:'Active', avatar:'RM' },
];

const ROLE_NAME_MAP = {
 'General Manager': 'SUPER_ADMIN',
 'Front Desk': 'FRONT_OFFICE',
 'Kitchen Chef': 'KITCHEN_MANAGER',
 'Activity Manager': 'ACTIVITY',
 'Housekeeping': 'HOUSEKEEPING',
 'Accounts': 'ACCOUNTS',
 'Sales & CRM': 'SALES',
 'Sales Director': 'SALES_DIRECTOR',
 'Reports & Analytics': 'ADMIN',
};


// ── SESSION TIMEOUT ──────────────────────────────────────────────────────────
const INACTIVITY_TIMEOUT = 30 * 60 * 1000; // 30 minutes
const WARNING_BEFORE = 2 * 60 * 1000; // warn 2 mins before
const SESSION_LOG_KEY = 'botanix_session_log';

function getDeviceInfo() {
 const ua = navigator.userAgent;
 const browser = ua.includes('Chrome') ? 'Chrome' : ua.includes('Firefox') ? 'Firefox' : ua.includes('Safari') ? 'Safari' : 'Browser';
 const device = /Mobile|Android|iPhone/.test(ua) ? 'Mobile' : /iPad|Tablet/.test(ua) ? 'Tablet' : 'Desktop';
 const os = ua.includes('Windows') ? 'Windows' : ua.includes('Mac') ? 'macOS' : ua.includes('Android') ? 'Android' : ua.includes('iPhone') ? 'iOS' : 'Unknown';
 return { browser, device, os };
}

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
 const [user, setUser] = useState(null);
 const [users, setUsers] = useState(SAMPLE_USERS);
 const [loading, setLoading] = useState(true);
 const [sessionId, setSessionId] = useState(null);
 const [sessionLog, setSessionLog] = useState(() => {
 try { return JSON.parse(localStorage.getItem(SESSION_LOG_KEY)||'[]'); }
 catch { return []; }
 });

 useEffect(() => {
 fetch(`${API}/sessions/users`)
 .then(r => r.json())
 .then(d => {
 if (Array.isArray(d) && d.length > 0) {
 const mapped = d.map(u => ({
 id: u.id, name: u.name, email: u.email, mobile: u.phone || '',
 password: null, role: ROLE_NAME_MAP[u.role] || 'STAFF',
 roleName: u.role, dept: u.role || 'Staff',
 resort: 'Botanix Damdama',
 status: u.status === 'active' ? 'Active' : 'Inactive',
 avatar: u.name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase(),
 }));
 setUsers(mapped);
 }
 })
 .catch(() => {});
 }, []);

 useEffect(() => {
 const stored = localStorage.getItem('botanix_user');
 if (stored) {
 try { setUser(JSON.parse(stored)); } catch(e) {}
 }
 setLoading(false);
 }, []);

 const login = async (emailOrMobile, password) => {
 try {
 const res = await fetch(`${API}/sessions/login`, {
 method: 'POST',
 headers: { 'Content-Type': 'application/json' },
 body: JSON.stringify({ email: emailOrMobile, password }),
 });
 const data = await res.json();
 if (res.ok && data.success) {
 const roleKey = ROLE_NAME_MAP[data.user.role] || 'STAFF';
 const { browser, device, os } = getDeviceInfo();
 const loginTime = new Date().toISOString();
 const sid = Date.now();
 const session = {
 id: sid, userId: data.user.id, userName: data.user.name,
 userRole: ROLES[roleKey] || data.user.role,
 userEmail: data.user.email, userDept: data.user.role || '',
 loginAt: loginTime, logoutAt: null, durationMins: null,
 browser, device, os, ipAddress: 'Online', status: 'Active',
 };
 const newLog = [session, ...sessionLog].slice(0, 500);
 setSessionLog(newLog);
 localStorage.setItem(SESSION_LOG_KEY, JSON.stringify(newLog));
 setSessionId(sid);
 const sessionUser = {
 ...data.user, role: ROLES[roleKey] || data.user.role,
 roleKey, avatar: data.user.name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase(),
 loginTime, dept: data.user.role || '',
 };
 setUser(sessionUser);
 localStorage.setItem('botanix_user', JSON.stringify(sessionUser));
 return { success: true, user: sessionUser };
 }
 } catch (e) {}

 // Fallback to local SAMPLE_USERS
 const found = users.find(u =>
 (u.email === emailOrMobile || u.mobile === emailOrMobile) &&
 u.password === password &&
 u.status === 'Active'
 );
 if (!found) return { success: false, error: 'Invalid credentials or account inactive' };
 const { browser, device, os } = getDeviceInfo();
 const loginTime = new Date().toISOString();
 const sid = Date.now();
 const session = {
 id: sid, userId: found.id, userName: found.name, userRole: found.role,
 userEmail: found.email, userDept: found.dept,
 loginAt: loginTime, logoutAt: null, durationMins: null,
 browser, device, os, ipAddress: 'LAN / Local', status: 'Active',
 };
 const newLog = [session, ...sessionLog].slice(0, 500);
 setSessionLog(newLog);
 localStorage.setItem(SESSION_LOG_KEY, JSON.stringify(newLog));
 setSessionId(sid);
 const sessionUser = { ...found, password: undefined, roleKey: found.role, loginTime };
 setUser(sessionUser);
 localStorage.setItem('botanix_user', JSON.stringify(sessionUser));
 return { success: true, user: sessionUser };
 };

 const logout = () => {
 if (sessionId) {
 const logoutTime = new Date().toISOString();
 const loginTime = user?.loginTime;
 const durationMins = loginTime ? Math.round((new Date(logoutTime) - new Date(loginTime)) / 60000) : null;
 const newLog = sessionLog.map(s => s.id === sessionId ? { ...s, logoutAt: logoutTime, durationMins, status: 'Ended' } : s);
 setSessionLog(newLog);
 localStorage.setItem(SESSION_LOG_KEY, JSON.stringify(newLog));
 }
 setUser(null);
 setSessionId(null);
 localStorage.removeItem('botanix_user');
 };

 const createUser = async (userData) => {
 try {
 const res = await fetch(`${API}/sessions/users`, {
 method: 'POST',
 headers: { 'Content-Type': 'application/json' },
 body: JSON.stringify(userData),
 });
 const data = await res.json();
 if (!res.ok) throw new Error(data.error || 'Failed to create user');
 const usersRes = await fetch(`${API}/sessions/users`);
 const usersData = await usersRes.json();
 if (Array.isArray(usersData)) {
 const mapped = usersData.map(u => ({
 id: u.id, name: u.name, email: u.email, mobile: u.phone || '',
 password: null, role: ROLE_NAME_MAP[u.role] || 'STAFF',
 dept: u.role || 'Staff', resort: 'Botanix Damdama',
 status: u.status === 'active' ? 'Active' : 'Inactive',
 avatar: u.name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase(),
 }));
 setUsers(mapped);
 }
 return { success: true, user: data };
 } catch (err) { return { success: false, error: err.message }; }
 };

 const resetPassword = async (userId, newPassword) => {
 try {
 const res = await fetch(`${API}/sessions/users/${userId}/password`, {
 method: 'PUT',
 headers: { 'Content-Type': 'application/json' },
 body: JSON.stringify({ password: newPassword }),
 });
 const data = await res.json();
 if (!res.ok) throw new Error(data.error || 'Failed to reset password');
 return { success: true };
 } catch (err) { return { success: false, error: err.message }; }
 };

 const updateUser = async (userId, userData) => {
 try {
 const res = await fetch(`${API}/sessions/users/${userId}`, {
 method: 'PUT',
 headers: { 'Content-Type': 'application/json' },
 body: JSON.stringify(userData),
 });
 const data = await res.json();
 if (!res.ok) throw new Error(data.error || 'Failed to update user');
 const usersRes = await fetch(`${API}/sessions/users`);
 const usersData = await usersRes.json();
 if (Array.isArray(usersData)) {
 const mapped = usersData.map(u => ({
 id: u.id, name: u.name, email: u.email, mobile: u.phone || '',
 password: null, role: ROLE_NAME_MAP[u.role] || 'STAFF',
 dept: u.role || 'Staff', resort: 'Botanix Damdama',
 status: u.status === 'active' ? 'Active' : 'Inactive',
 avatar: u.name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase(),
 }));
 setUsers(mapped);
 }
 return { success: true };
 } catch (err) { return { success: false, error: err.message }; }
 };

 const hasAccess = (module, minPerm = PERMS.VIEW) => {
 if (!user) return false;
 const roleKey = user.roleKey || user.role;
 if (roleKey === 'SUPER_ADMIN' || roleKey === 'Super Admin') return true;
 const matrix = ACCESS_MATRIX[module];
 if (!matrix) return false;
 return (matrix[roleKey] ?? 0) >= minPerm;
 };

 return (
 <AuthContext.Provider value={{
 user, users, setUsers, loading, sessionLog,
 login, logout, createUser, updateUser, resetPassword,
 hasAccess,
 canView: m => hasAccess(m, PERMS.VIEW),
 canCreate: m => hasAccess(m, PERMS.CREATE),
 canEdit: m => hasAccess(m, PERMS.EDIT),
 canApprove: m => hasAccess(m, PERMS.APPROVE),
 canDelete: m => hasAccess(m, PERMS.DELETE),
 canExport: m => hasAccess(m, PERMS.EXPORT),
 isAdmin: () => user?.roleKey === 'SUPER_ADMIN' || user?.roleKey === 'ADMIN' || user?.role === 'Super Admin' || user?.role === 'Admin',
 isSuperAdmin: () => user?.roleKey === 'SUPER_ADMIN' || user?.role === 'Super Admin',
 ROLES, PERMS, ACCESS_MATRIX,
 }}>
 {children}
 </AuthContext.Provider>
 );
}

export const useAuth = () => {
 const ctx = useContext(AuthContext);
 if (!ctx) throw new Error('useAuth must be used inside AuthProvider');
 return ctx;
};
